<script setup>
  import { Authenticator } from "@aws-amplify/ui-vue";
  import "@aws-amplify/ui-vue/styles.css";

  import { Amplify } from 'aws-amplify';
  import awsconfig from './aws-exports';

  Amplify.configure(awsconfig);
</script>
<template>
  <authenticator :login-mechanisms="['email']" :hide-sign-up="true">
    <template v-slot="{ user, signOut }">
      <div id="app">
        <router-view />
      </div>
    </template>
  </authenticator>
</template>
<script>
export default {
  name: "App",
  created () {
      document.title = process.env.VUE_APP_TITLE;
  },
  data: function () {
    return { status: false };
  },
  mounted() {

    $("ul.tabs li").click(function () {
      var $this = $(this);
      var $theTab = $(this).attr("id");
      console.log($theTab);
      if ($this.hasClass("active")) {
        // do nothing
      } else {
        $this
          .closest(".tabs_wrapper")
          .find("ul.tabs li, .tabs_container .tab_content")
          .removeClass("active");
        $(
          '.tabs_container .tab_content[data-tab="' +
            $theTab +
            '"], ul.tabs li[id="' +
            $theTab +
            '"]'
        ).addClass("active");
      }
    });
 
  },
};
</script>
